import { ApiGrid } from "../controls/ApiGrid";
import { type Continent } from '../../../../lecturas-common/location/continents.model';
import { Column, ColumnType } from "@syncfusion/react-grid";
import { ContinentsDataSource } from "../../services/continents-data-source";



export const ContinentsPage = () => {

    const dataSource = new ContinentsDataSource();

    return (
        <ApiGrid<Continent> dataSource={dataSource}>
            <Column field="id" isPrimaryKey={true} isIdentity={true} validationRules={{required: false}} visible={false}/>
            <Column field="name" validationRules={{required: true, minLength: 4}}  headerText="Nombre"/>
            <Column 
            field="createdAt" 
            headerText="Creado" 
            type={ColumnType.DateTime} 
            format={{type:'date', format: 'dd/MM/yyyy HH:mm:ss'}} 
            editTemplate={<p></p>}
            validationRules={{required: false}} 
            allowEdit={false}/>
            <Column 
            field="updatedAt" 
            headerText="Actualizado" 
            type={ColumnType.DateTime} 
            format={{type:'date', format: 'dd/MM/yyyy HH:mm:ss'}} 
            editTemplate={<p></p>}
            validationRules={{required: false}} 
            allowEdit={false}/>         
        </ApiGrid>
    );
}